import { CreateLiveMentionManualDto, DateTimeStr, now, Station } from '@mi-front/core';
import { DateTimeField, Form, Modal } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../core/hooks';
import { MentionNameFields } from './MentionNameFields';
import { createLiveMentionManualSchema } from './validation';

interface Props {
  station: Station;
  datetime?: DateTimeStr;
  submitFn: (data: CreateLiveMentionManualDto) => Promise<any>;
  cancel: () => any;
}

export type LiveMentionManualFormValues = {
  datetime: string;
  source: 'schedules' | 'custom';
  mentionSchedules: null | { name: string; description: string };
  mentionCustom: { name: string; description: string };
};

export function LiveMentionManualForm({ station, datetime, submitFn, cancel }: Props) {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <Form<LiveMentionManualFormValues>
      initialValues={{
        datetime: datetime || now(),
        source: 'schedules',
        mentionSchedules: null,
        mentionCustom: {
          name: '',
          description: '',
        },
      }}
      validationSchema={createLiveMentionManualSchema}
      onSubmit={(data) => {
        return submitFn({
          datetime: data.datetime as DateTimeStr,
          ...(data.source === 'schedules' ? data.mentionSchedules! : data.mentionCustom),
        });
      }}
      onCancel={cancel}
      actions={(formikProps, defaultActions) => <Modal.Footer>{defaultActions}</Modal.Footer>}
    >
      <Modal.Body>
        <div className="row">
          <div className="col-10">
            <DateTimeField
              name="datetime"
              dateLabel={$t({
                id: 'common.text.date',
                defaultMessage: 'Fecha',
              })}
              timeLabel={$t({
                id: 'common.text.time',
                defaultMessage: 'Hora',
              })}
              isOutsideRange={(date) => moment(date) > moment()}
              tz={tz}
              withSeconds
              markRequired
            />
          </div>
        </div>
        <MentionNameFields station={station} />
      </Modal.Body>
    </Form>
  );
}
